export function prefixAgentMessage(message) {
    return `[Grafana JavaScript Agent] ${message}`;
}
//# sourceMappingURL=prefixAgentMessage.js.map